// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

console.log(process.env.REACT_APP_ECHO_VIBE_FIREBASE_API_KEY, "ENV")
const firebaseConfig = {
    apiKey: process.env.REACT_APP_ECHO_VIBE_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_ECHO_VIBE_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_ECHO_VIBE_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_ECHO_VIBE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_ECHO_VIBE_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_ECHO_VIBE_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_ECHO_VIBE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();